export const removeNullValuesFromObject = <T extends Record<string, unknown>>(params: T): T => {
  for (const key in params) {
    const value = params[key];
    if (value === null || value === undefined || value === '') {
      delete params[key];
    }
  }
  return params;
};
